import type { App } from 'vue'
import sentry from '@/plugins/sentry'
import vuetify from '@/plugins/vuetify'
import gtag from '@/plugins/gtag'

export function registerPlugins(app: App) {
  app.use(sentry)
  app.use(vuetify)
  app.use(gtag)
}
